import Vue from 'vue';
import Chat from './Chat.vue';

window.axios = require('axios');

let div = document.createElement('div');
div.setAttribute('id', 'swell-cx');

document.body.appendChild(div);

new Vue({
    el: '#swell-cx',
    components: { Chat },
    render(h) {
        return h(Chat);
    }
});
